module.exports = __webpack_public_path__ + "static/image1-e3fe36c090adff6ce04ec98b3562359d.jpg";